import React from "react";
import parse from "html-react-parser";
import { fetchAppInfo } from "../../network/service";
import { useEffect } from "react";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Loading from "../../Components/Loading/Loading";


const Disclaimer = () => {
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState("");
  useEffect(() => {
    window.scroll(0, 0)
    fetchPrivacyPolicyData();
  }, []);
  const fetchPrivacyPolicyData = async () => {
    setLoading(true)
    try {
      const params = {
        type: "DISCLAIMER",
      };
      const response = await fetchAppInfo(params);
      if (response?.status === 200) {
        setData(response?.data?.data?.value);
        setLoading(false)

      }
    } catch (err) {
      setLoading(false)
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }

  };

  if (loading) {
    return (
      <Loading />
    )
  }

  return (
    <div className="privacyPolicy">
      <ToastContainer />

      <div className="wrapper">{parse(data)}</div>
      {/* <div dangerouslySetInnerHTML={{__html: '<strong>strong text</strong>'}} /> */}
    </div>
  );
};

export default Disclaimer;
